import React from 'react';

import { MenuItemProps } from '@mui/material'

import { Option } from './styled';

export const DropdownOption = React.memo(
  function DropdownOption<C extends React.ElementType>(props: MenuItemProps<C, { component?: C }>) {
    const { children, ...others } = props;

    return (
      <Option {...others}>
        {children}
      </Option>
    );
  }
);
